import Box from "@mui/material/Box"
import {
  useFocusable,
  FocusContext,
  getCurrentFocusKey,
} from "@noriginmedia/norigin-spatial-navigation"
import clsx from "clsx"
import React, { useEffect } from "react"
import { Pages } from "src/App"

import useTranslate from "../../hooks/use-translate"
import { focusStore } from "../../store/FocusStore"
import { CuratedContentSlugV2, s } from "../../utilities/common"
import { deviceResolution, nonStandardFormat } from "../../utilities/constants"
import { useRouteMatch } from "../../utilities/use-route-match"
import { SettingsIcon } from "../common/icons/SettingsIcon"

import "./TabBar.css"

import { Tab } from "./Tab"

export const TabBar = () => {
  const t = useTranslate()
  const isMyRoute = useRouteMatch()

  const tabFocusGuard = focusStore((state) => state.tabFocusGuard)

  const { ref, focusKey, focusSelf } = useFocusable({
    focusKey: "TABBAR",
    onFocus: (_, __, query) => {
      if (!(query && query.noScroll) && isMyRoute)
        document.getElementById("root")!.style.transform =
          "translate3d(0, 0, 0)"
    },
    isFocusBoundary: true,
    focusBoundaryDirections: tabFocusGuard
      ? ["left", "right", "up", "down"]
      : ["left", "right", "up"],
  })
  useEffect(() => {
    setTimeout(() => {
      if (!getCurrentFocusKey()) focusSelf()
    }, 200)
  }, [focusSelf])

  return (
    <FocusContext.Provider value={focusKey}>
      <Box
        ref={ref}
        className={clsx(
          "TabBar",
          deviceResolution === 720 && "small",
          nonStandardFormat && "dynamic",
        )}
        sx={{ mt: s("49px"), mb: s("43px") }}
        style={nonStandardFormat ? { borderRadius: s("36px") } : undefined}
      >
        <Tab route={CuratedContentSlugV2.Discover}>
          <span>{t("navigation__discover")}</span>
        </Tab>
        <Tab route={CuratedContentSlugV2.Audio}>
          <span>{t("navigation__audio")}</span>
        </Tab>
        <Tab route={CuratedContentSlugV2.Live}>
          <span>{t("navigation__live")}</span>
        </Tab>
        <Tab route={CuratedContentSlugV2.Search}>
          <span>{t("navigation__search")}</span>
        </Tab>
        <Tab route={Pages.MyStage}>
          <span>{t("navigation__mystage")}</span>
        </Tab>
        <Tab route={Pages.Settings} width={70} svg>
          <SettingsIcon />
        </Tab>
      </Box>
    </FocusContext.Provider>
  )
}
